import { apiService } from './api'
import { UserResponse } from './authService'

export interface AdminSecurityStatus {
  totp_enabled: boolean
  pending_email: string | null
  email: string
}

export interface AdminMfaSetupResponse {
  secret: string
  otpauth_url: string
}

export interface AdminLoginTokenResponse {
  access_token: string
  token_type: string
  user: UserResponse
  user_id: string
  user_type: string
}

class AdminSecurityService {
  async getStatus(): Promise<AdminSecurityStatus> {
    return apiService.get<AdminSecurityStatus>('/auth/admin-security/status')
  }

  async setup2fa(): Promise<AdminMfaSetupResponse> {
    return apiService.post<AdminMfaSetupResponse>('/auth/admin-security/2fa/setup')
  }

  async confirm2fa(code: string): Promise<{ success: boolean; totp_enabled: boolean }> {
    return apiService.post('/auth/admin-security/2fa/confirm', { code })
  }

  async disable2fa(code: string, password: string): Promise<{ success: boolean; totp_enabled: boolean }> {
    return apiService.post('/auth/admin-security/2fa/disable', { code, password })
  }

  async verify2faLogin(mfaToken: string, code: string): Promise<AdminLoginTokenResponse> {
    return apiService.post<AdminLoginTokenResponse>('/auth/admin-security/verify-2fa', {
      mfa_token: mfaToken,
      code,
    })
  }

  async requestEmailChange(
    newEmail: string,
    password: string,
    totpCode: string,
  ): Promise<{ success: boolean; message: string }> {
    return apiService.post('/auth/admin-security/email/request-change', {
      new_email: newEmail,
      password,
      totp_code: totpCode,
    })
  }

  async confirmEmailChange(
    newEmail: string,
    emailCode: string,
    totpCode: string,
  ): Promise<UserResponse> {
    return apiService.post<UserResponse>('/auth/admin-security/email/confirm-change', {
      new_email: newEmail,
      email_code: emailCode,
      totp_code: totpCode,
    })
  }
}

export const adminSecurityService = new AdminSecurityService()
export default adminSecurityService
